import {useMemo} from 'react';
import {assertPrizeValue} from 'services/utils';
import {IconButton, Layout, Text} from 'components';
import type {EntityPreviewHeader} from './types';

export const PrizePreviewHeader: EntityPreviewHeader = ({
  entityValue,
  onEdit,
}) => {
  const prize = assertPrizeValue(entityValue);
  const {title, handleEdit} = useMemo(() => {
    return {
      title: prize.name ?? '',
      handleEdit: onEdit ? () => Promise.resolve(onEdit(prize)) : undefined,
    };
  }, [prize, onEdit]);

  return (
    <Layout
      paddingLeft={2}
      paddingRight={1}
      alignItems="center"
      justifyContent="space-between"
      horizontal
      flex={1}>
      <Layout horizontal adjustCenter>
        <Text variant="h2">{title}</Text>
      </Layout>
      {handleEdit ? (
        <Layout horizontal adjustCenter>
          <IconButton icon="Edit" onClick={handleEdit} />
        </Layout>
      ) : null}
    </Layout>
  );
};
